import {BlockedACHContent} from "@bounce/shared/consumer/pages/payment";
import {InputUtils} from "@bounce/shared/helpers";
import NiceModal, {NiceModalHocProps} from "@ebay/nice-modal-react";
import {Pages} from "~/bi-events/enum";
import {useWebchat} from "~/components/webchat/useWebchat";
import {useAmplitude} from "~/contexts";
import React, {useCallback, useEffect} from "react";

interface BlockedACHDialogProps extends NiceModalHocProps {
  secondaryButtonText: string;
  closePaymentDialogHandler?: () => void;
}

const BlockedACHDialog = NiceModal.create(({secondaryButtonText, closePaymentDialogHandler}: BlockedACHDialogProps) => {
  const {pageViewEvent, pageClickEvent} = useAmplitude();
  const {openChat} = useWebchat();

  const gotItHandler = useCallback(async (): Promise<void> => {
    pageClickEvent({page: Pages.BLOCKED_ACH, cta: "got_it"});
  }, []);

  const ContactUsHandler = useCallback(async (): Promise<void> => {
    pageClickEvent({page: Pages.BLOCKED_ACH, cta: secondaryButtonText});
    if (closePaymentDialogHandler) {
      closePaymentDialogHandler();
    }
    openChat({});
  }, []);

  useEffect(() => {
    pageViewEvent({page: Pages.BLOCKED_ACH_DIALOG});
  }, []);

  return (
    <BlockedACHContent
      gotItHandler={gotItHandler}
      secondaryButtonText={InputUtils.prettierSnakeCaseSentence(secondaryButtonText)}
      onClickSecondary={ContactUsHandler}
    />
  );
});

export default BlockedACHDialog;
